module.exports = __webpack_public_path__ + "img/3bff3c9.jpg";